export default __webpack_public_path__ + "static/treasure-bamboo-desktop-9436ca6a7eb297f67ab56f83c9b417a0.png";